import * as React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { TRUST_BADGES_ORIENTATION, TRUST_BADGES_SIZE } from './types/trust-badges-enums';
import type { TrustBadgesProps } from './types/trust-badges-types';


const sizeConfig = {
  sm: {
    icon: 'h-3.5 w-3.5 text-content-primary',
    text: 'text-xs font-medium text-content-primary',
    badge: 'inline-flex items-center gap-2',
    wrapper: 'gap-4',
  },
  md: {
    icon: 'h-4 w-4 text-content-primary',
    text: 'type-body font-medium text-content-primary',
    badge: 'inline-flex items-center gap-2',
    wrapper: 'gap-5',
  },
} as const;

export function TrustBadges({
  badges,
  orientation = TRUST_BADGES_ORIENTATION.HORIZONTAL,
  size = TRUST_BADGES_SIZE.SM,
  className,
  ...props
}: TrustBadgesProps) {
  const config = sizeConfig[size];

  return (
    <div
      className={cn(
        'flex items-center',
        orientation === TRUST_BADGES_ORIENTATION.HORIZONTAL ? `flex-wrap ${config.wrapper}` : `flex-col ${config.wrapper}`,
        className
      )}
      {...props}
    >
      {badges.map(badge => {
        const content = (
          <div key={badge.label} className={config.badge}>
            <span className={config.icon}>{badge.icon}</span>
            <span className={config.text}>{badge.label}</span>
          </div>
        );

        if (badge.tooltip) {
          return (
            <Tooltip key={badge.label}>
              <TooltipTrigger asChild>{content}</TooltipTrigger>
              <TooltipContent>{badge.tooltip}</TooltipContent>
            </Tooltip>
          );
        }

        return content;
      })}
    </div>
  );
}

